import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getPublicFAQs } from '../services/faqService';

const CLIENT_CATEGORIES = [
  { id: 'getting-started', label: 'Getting Started' },
  { id: 'bookings', label: 'Bookings' },
  { id: 'payments', label: 'Payments' },
  { id: 'account', label: 'Account' },
  { id: 'safety', label: 'Safety' },
];

export const usePublicFAQs = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['publicFAQs'],
    queryFn: async () => {
      const response = await getPublicFAQs();
      return response.data;
    },
  });

  const faqs = useMemo(() => {
    const raw = data?.data || data;
    return Array.isArray(raw) ? raw : [];
  }, [data]);

  const faqsByCategory = useMemo(() => {
    const grouped = {};
    CLIENT_CATEGORIES.forEach((cat) => {
      grouped[cat.id] = faqs
        .filter((f) => (f.category || 'general') === cat.id)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
    });
    return grouped;
  }, [faqs]);

  return {
    faqs,
    faqsByCategory,
    categories: CLIENT_CATEGORIES,
    isLoading,
    error,
  };
};
